import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (userId, password) => {
    const res = await api.post("/auth/login", { user_id: userId, password });
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
    window.location.href = "/";
  };

  const can = (perm) => {
    if (!user) return false;
    if (user.role === "super_admin" || user.role === "admin") return true;
    return (user.permissions || []).includes(perm);
  };
  const canAny = (...perms) => perms.some((p) => can(p));
  const isAdmin = () => user && (user.role === "super_admin" || user.role === "admin");

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, login, logout, can, canAny, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};
